
import TitlePages from '../components/TitlePages'
import NewsFeed from '../components/News/NewsFeed'
export default {
  components: {
    TitlePages,
    NewsFeed
  },
  data () {
    return {
      title: '',
      color: '',
      data: ''
    }
  },
  created () {
    this.Getdata()
  },
  methods: {
    Getdata () {
      this.$axios.get('https://' + this.$host + '/news').then(res => {
        if (res.data.length > 0) {
          this.data = res.data
        }
      })
    }
  }
}
